import React, { useState } from 'react'
import Dropzone from 'react-dropzone';
// import { Icon } from 'antd';
import Axios from 'axios';
// import './carousel.css'


function FileUpload(props) {
    
    var Url =window.location.protocol + '//' + window.location.host
    const [Images, setImages] = useState([])

    const onDrop = (files) => {
        console.log(files)
        var img = Images
        
        if(files.length > 1){
         for(let i=0;i<files.length;i++){
             img.push(files[i])
         }
        }
        else if(files.length == 1){
            img.push(files[0])
        }
        setImages(img)
        props.refresh(Images)
    
    }


    return (
        < >
            <Dropzone
                onDrop={onDrop}
                multiple={true}
                maxSize={800000000}
                className="dropZone"
            >
                {({ getRootProps, getInputProps }) => (
                    <div style={{
                        zIndex: '1000',
                        position: 'relative',
                    }}
                        {...getRootProps()}
                    >
                        <input {...getInputProps()} />

                    </div>
                )}
            </Dropzone>


        </>
    )
}

export default FileUpload
